import type { LocaleMessageBundle } from '../../types'
import { branchMessages as branchFeatureMessages } from './branch'

export const branchMessages: LocaleMessageBundle = {
  vi: {
    ...branchFeatureMessages.vi,
  },
  en: {
    ...branchFeatureMessages.en,
  },
}
